import App from "../App";

App.config = App.config || {};

App.config.stencil = {};

App.config.stencil.groups = {
	premium: { index: 0, label: "Premium" },
	standard: { index: 1, label: "Standard" },	
	private: { index: 2, label: "PBN"}
	// standard: { index: 1, label: "Standard shapes" },
	// fsa: { index: 2, label: "State machine" },
	// pn: { index: 3, label: "Petri nets" },
	// erd: { index: 4, label: "Entity-relationship" },
	// uml: { index: 5, label: "UML" },
	// org: { index: 6, label: "ORG" }
};

App.config.stencil.shapes = {};

App.config.stencil.shapes.premium = [
	{
		type: "rankerx.SocialNetworkPremium",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Social Network/Web 2.0 Blog Premium",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},
	{
		type: "rankerx.WebProfilePremium",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Web 2.0 Profile Premium/Edu/Gov",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},
	{
		type: "rankerx.BookmarkingPremium",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Bookmarking Premium",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},
	{
		type: "rankerx.PDFPremium",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "PDF Premium",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},	
	{
		type: "rankerx.ArticleDirectoryPremium",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Article Directory Premium",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},			
	{
		type: "rankerx.PressReleasePremium",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Press Release Premium",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},	
];

App.config.stencil.shapes.standard = [
	// {
	// 	type: "rankerx.Project",
	// 	attrs: {
	// 		root: {
	// 			dataTooltip: "Money Site",
	// 			dataTooltipPosition: "left",
	// 			dataTooltipPositionSelector: ".joint-stencil"
	// 		},
	// 		body: {
	// 			fill: "transparent",
	// 			stroke: "#3e9c35",
	// 			strokeWidth: 2,
	// 			strokeDasharray: "0"
	// 		},
	// 		header: {
	// 			stroke: "#3e9c35",
	// 			fill: "#3e9c35",
	// 			strokeWidth: 2,
	// 			strokeDasharray: "0",
	// 			height: 20
	// 		},
	// 		web20: {
	// 			stroke: "#3b5998",
	// 			fill: "#3b5998",
	// 			strokeWidth: 2,
	// 			strokeDasharray: "0",
	// 			height: 0
	// 		},
	// 		bodyText: {
	// 			text: "",
	// 			fill: "#c6c7e2",
	// 			fontFamily: "sans-serif, Arial",
	// 			fontWeight: "Normal",
	// 			fontSize: 11,
	// 			strokeWidth: 0,
	// 			refY2: 12
	// 		},
	// 		headerText: {
	// 			text: "Money Site",
	// 			fill: "#f6f6f6",
	// 			fontFamily: "sans-serif, Arial",
	// 			fontWeight: "Bold",
	// 			fontSize: 11,
	// 			strokeWidth: 0,
	// 			refY: 12
	// 		}
	// 	}
	// },
	{
		type: "rankerx.SocialNetwork",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Social Network/Web 2.0 Blog",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},
	{
		type: "rankerx.WebProfile",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Web 2.0 Profile",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},	
	{
		type: "rankerx.Wiki",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Wiki",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},
	{
		type: "rankerx.ArticleDirectory",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Article Directory",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},
	{
		type: "rankerx.Bookmarking",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Bookmarking",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},	
	{
		type: "rankerx.ForumProfile",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Forum Profile",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	}
];

App.config.stencil.shapes.private = [
	{
		type: "rankerx.Private",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Private Blog",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	},
	{
		type: "rankerx.PrivateBookmark",
		size: { width: 5, height: 3 },
		attrs: {
			root: {
				dataTooltip: "Private Bookmark",
				dataTooltipPosition: "left",
				dataTooltipPositionSelector: ".joint-stencil"
			}
		}
	}
]